/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Paper,
  Grid,
  Typography,
} from '@material-ui/core';
import cloneDeep from 'lodash/cloneDeep';
import PropTypes from 'prop-types';
import CreateAndEditWrapper from '../share/CreateAndEditWrapper';
import { resourceFormStyle, commonResourceStyle } from '../../css/style';
import {
  tiersRewardType,
  resourceFields,
  validationErrorMessages,
} from '../../data/Constants';
import DisplayImages from '../share/DisplayImages';
import SearchableSelect from '../share/SearchableSelect';
import FormTextField from '../share/FormTextField';
import FormDropDownField from '../share/FormDropDownField';
import { buildUpSearchableProductsAndItems, createRequestData } from '../../utils/Functions';

const styles = resourceFormStyle();
const commonStyles = commonResourceStyle();
class CreateAndEditTier extends Component {
  constructor(props) {
    super(props);
    const { match, type, tiers } = this.props;
    const { resource, resourceId } = match.params;
    const fields = resourceFields[resource];
    const tierDetail = {};
    fields.forEach((field) => {
      const { key } = field;
      const detail = {
        ...field,
        value: key === 'productItems' ? [] : null,
        errorMessage: '',
        isValid: true,
      };
      tierDetail[key] = detail;
    });

    if (type === 'edit') {
      const itemToEdit = tiers.find(tier => tier.id === parseInt(resourceId));
      Object.values(tierDetail).forEach((detail) => {
        const { key } = detail;
        detail.value = itemToEdit ? itemToEdit[key] : '';
      });
    }

    this.state = {
      tierDetail,
    };
  }

  componentDidMount() {
    const { type } = this.props;
    if (type === 'edit') {
      const initialState = this.createState();
      this.setState({ ...initialState }, () => {
        this.prepareProductItems();
      });
    } else {
      this.prepareProductItems();
    }
  }

  createState = () => {
    const { tiers, match } = this.props;
    const {
      resource, resourceId, subResource,
    } = match.params;
    const resourceType = (subResource) || (resource);
    const fields = resourceFields[resourceType];
    const dialogState = {
      openEditDialog: false,
      editDialogField: null,
      newContent: '',
    };
    const state = {};
    const itemToEdit = tiers.find(tier => tier.id === parseInt(resourceId));
    state.id = resourceId;
    state.dialogState = dialogState;
    state.disableSaveButton = false;
    state.errorText = '';
    // eslint-disable-next-line no-return-assign
    fields.map(field => state[field.key] = itemToEdit && itemToEdit[field.key]);
    return state;
  };

  prepareProductItems = () => {
    const {
      apiToken, actions, loading,
    } = this.props;
    if (loading === false) {
      const ids = Array.isArray(this.state.productItems) ? this.state.productItems : [];
      actions.getAllResources(apiToken, 'products')
        .then((res) => {
          if (res.error) return;
          const { searchableProductItems } = buildUpSearchableProductsAndItems(res, true);
          const productItems = searchableProductItems.filter(
            searchableItem => ids.includes(searchableItem.value),
          );
          this.setState({
            searchableProductItems, productItems,
          });
        });
    }
  };

  areFieldsValid = () => {
    const { tierDetail } = this.state;
    let areAllValid = true;
    const copyOfTierDetail = cloneDeep(tierDetail);
    const { isRequiredError } = validationErrorMessages.field;
    if (copyOfTierDetail.rewardType.value === 'ITEM') {
      copyOfTierDetail.dollarAmount.isRequired = false;
    }
    Object.values(copyOfTierDetail).forEach((detail) => {
      const { isRequired, value } = detail;
      if (isRequired && !value) {
        detail.isValid = false;
        detail.errorMessage = isRequiredError;
        areAllValid = false;
      } else if (!detail.isValid) {
        areAllValid = false;
      }
    });
    if (!areAllValid) {
      this.setState({
        tierDetail: copyOfTierDetail,
      });
    }
    return areAllValid;
  }

  onClickApplyChanges = async () => {
    const {
      actions,
      history,
      apiToken,
      match,
      type,
    } = this.props;
    const {
      resource,
      resourceId,
    } = match.params;
    const { tierDetail } = this.state;

    const requestData = createRequestData(tierDetail);
    const resourcePath = type === 'edit' ? [resource, resourceId] : [resource];
    if (!this.areFieldsValid()) {
      return;
    }
    const { updateTier, addTier } = actions;
    const action = type === 'edit' ? updateTier : addTier;
    action(apiToken, requestData, ...resourcePath).then(async (res) => {
      if (res.error) {
        return;
      }
      history.push(`/${resource}`);
    });
  }

  handleValueChange = ({ newValue, key, errorMsg }) => {
    const { tierDetail } = this.state;
    const updatedDetail = cloneDeep(tierDetail);
    const updatedField = updatedDetail[key];
    updatedField.value = newValue;
    updatedField.errorMessage = errorMsg;
    updatedField.isValid = !updatedField.errorMessage;
    this.setState({
      tierDetail: updatedDetail,
    });
  }

  onChangeImage = (image) => {
    const { tierDetail } = this.state;
    const updatedDetail = cloneDeep(tierDetail);
    const updatedField = updatedDetail.image;
    updatedField.value = image;
    this.setState({
      tierDetail: updatedDetail,
    });
  };

  onChangeSearchableInput = (items) => {
    const { tierDetail } = this.state;
    const updatedDetail = cloneDeep(tierDetail);
    const updatedField = updatedDetail.productItems;
    updatedField.value = items.map(item => item.value);
    this.setState({
      tierDetail: updatedDetail,
    });
    const finalValue = !items ? [] : items;
    this.setState({ productItems: finalValue });
  }

  render() {
    const {
      tierDetail,
      searchableProductItems,
      productItems,
    } = this.state;
    const {
      name,
      dollarAmount,
      description,
      image,
      points,
      rewardType,
    } = tierDetail;
    const options = Array.isArray(searchableProductItems) ? searchableProductItems : [];
    return (
      <CreateAndEditWrapper
        {...this.props}
        onClickApplyChanges={this.onClickApplyChanges}
      >
        <Paper style={commonStyles.paperNoHeight}>
          <form noValidate autoComplete="off" style={styles.formContainer}>
            <Grid
              container
              style={styles.createEditTierContainer}
            >
              <Grid
                container
                spacing={24}
                style={styles.createEditTierContainerNoImage}
              >
                <FormTextField
                  field={points}
                  handleValueChange={this.handleValueChange}
                />
                <FormTextField
                  field={name}
                  handleValueChange={this.handleValueChange}
                />
                { rewardType.value !== 'DOLLAR'
                    && (
                      <div style={styles.createEditTierDropdownContainer}>
                        <div style={styles.createEditTierDropdownTitle}>
                          <Typography style={styles.itemTitle}>Attached Items</Typography>
                        </div>
                        <SearchableSelect
                          isMulti
                          isClearable={false}
                          options={options}
                          onChange={items => this.onChangeSearchableInput(items)}
                          value={Array.isArray(productItems) ? productItems : []}
                        />
                      </div>
                    )}
                <FormTextField
                  field={description}
                  handleValueChange={this.handleValueChange}
                />
                <FormDropDownField
                  field={rewardType}
                  dropdownOptions={tiersRewardType}
                  handleValueChange={this.handleValueChange}
                />
                { rewardType.value === 'DOLLAR'
                    && (
                      <FormTextField
                        field={dollarAmount}
                        handleValueChange={this.handleValueChange}
                      />
                    )}
              </Grid>
              <div style={styles.createEditTierImage}>
                <DisplayImages
                  data={image.value}
                  onChange={this.onChangeImage}
                  allowMultiple={false}
                />
              </div>
            </Grid>
          </form>
        </Paper>
      </CreateAndEditWrapper>
    );
  }
}

CreateAndEditTier.propTypes = {
  match: PropTypes.objectOf(PropTypes.any).isRequired,
  type: PropTypes.string.isRequired,
  tiers: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
  apiToken: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
};

CreateAndEditTier.defaultProps = {
  tiers: [],
};

export default connect(
  state => ({
    tiers: state.get('tiers').toJS().tierList,
  }),
)(CreateAndEditTier);
